import React from 'react';
import withIcon from '../utilities/withIcon';

const IconDocumentPdf = () => {
  return (
    <g>
      <path d="M13 12v.8h-1.719v.96h1.406v.8h-1.406V16h-.937v-4H13zM4.94 0l10.011.012c.541 0 .986.41 1.043.936l.006.114V15.25a.75.75 0 0 1-1.493.102l-.007-.102V1.51L6.25 1.5v3.695c0 .541-.41.987-.936 1.044l-.114.006H1.5v9.004a.75.75 0 0 1-.648.743L.75 16a.75.75 0 0 1-.743-.648L0 15.249V4.934L4.94 0zm-.378 12c.938 0 1.407.48 1.407 1.28s-.625 1.28-1.407 1.28h-.625v1.28H3V12h1.563zm3.282 0c1.093 0 1.875.64 1.875 1.92 0 1.28-.781 1.92-1.875 1.92H6.437V12h1.407zm0 .8h-.469v2.24h.469c.625 0 .937-.32.937-1.12s-.469-1.12-.937-1.12zm-3.438 0h-.468v1.12h.468c.469 0 .625-.16.625-.48 0-.48-.156-.64-.625-.64zM4.75 2.308 2.311 4.745H4.75V2.307z" />
    </g>
  );
};

export default withIcon(IconDocumentPdf);
